import React from "react";
import UnderDevelopmentPage from "../../UnderDevelopment/UnderDevelopmentPage";

export default function LogMonitorConfig() {
  return <div><UnderDevelopmentPage/></div>;
}
